import { configureStore } from "@reduxjs/toolkit";
import { backendApi } from "./api"; // Replace with your actual API slice

export const store = configureStore({
  reducer: {
    // Add other slices as needed
    [backendApi.reducerPath]: backendApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(backendApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
